export default __webpack_public_path__ + "static/media/hon.a03a3b49.jpg";